var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._b({attrs:{"custom-class":_vm.customClass,"visible":_vm.dialogVisible,"center":"","close-on-press-escape":false,"close-on-click-modal":false,"title":_vm.title},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},'el-dialog',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }